// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/RangePoint.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type=range].styled-slider {
  height: 20px;
  -webkit-appearance: none;
}

/*progress support*/
input[type=range].styled-slider.slider-progress {
  --range: calc(var(--max) - var(--min));
  --ratio: calc((var(--value) - var(--min)) / var(--range));
  --sx: calc(0.5 * 2em + var(--ratio) * (100% - 2em));
}

input[type=range].styled-slider:focus {
  outline: none;
}

/*webkit*/
input[type=range].styled-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 1em;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border: none;
  margin-top: -4px;
}

input[type=range].styled-slider::-webkit-slider-runnable-track {
  height: 1em;
  border: 1px solid #8686ff;
  border-radius: 0.5em;
  background: #4343ff;
  box-shadow: none;
}

input[type=range].styled-slider::-webkit-slider-thumb:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

input[type=range].styled-slider:hover::-webkit-slider-runnable-track {
  background: #4343ff;
  border-color: #8686ff;
}

input[type=range].styled-slider::-webkit-slider-thumb:active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

input[type=range].styled-slider:active::-webkit-slider-runnable-track {
  background: #4343ff;
  border-color: #8686ff;
}

input[type=range].styled-slider.slider-progress::-webkit-slider-runnable-track {
  background: linear-gradient(#4343ff, #4343ff) 0/var(--sx) 100% no-repeat, #ffffff;
}

input[type=range].styled-slider.slider-progress:hover::-webkit-slider-runnable-track {
  background: linear-gradient(#4343ff, #4343ff) 0/var(--sx) 100% no-repeat, #ffffff;
}

input[type=range].styled-slider.slider-progress:active::-webkit-slider-runnable-track {
  background: linear-gradient(#4343ff, #4343ff) 0/var(--sx) 100% no-repeat, #ffffff;
}

/*mozilla*/
input[type=range].styled-slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 1em;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border: none;
  box-shadow: 0 0 2px black;
}

input[type=range].styled-slider::-moz-range-track {
  height: max(1em - 1px - 1px, 0px);
  border: 1px solid #8686ff;
  border-radius: 0.5em;
  background: #efefef;
  box-shadow: none;
}

input[type=range].styled-slider:hover::-moz-range-track {
  background: #e5e5e5;
  border-color: #8686ff;
}

input[type=range].styled-slider::-moz-range-thumb:active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

input[type=range].styled-slider:active::-moz-range-track {
  background: #f5f5f5;
  border-color: #8686ff;
}

input[type=range].styled-slider.slider-progress::-moz-range-track {
  background: linear-gradient(#8686ff, #8686ff) 0/var(--sx) 100% no-repeat, #efefef;
}

input[type=range].styled-slider.slider-progress:hover::-moz-range-track {
  background: linear-gradient(#8686ff, #8686ff) 0/var(--sx) 100% no-repeat, #e5e5e5;
}

input[type=range].styled-slider.slider-progress:active::-moz-range-track {
  background: linear-gradient(#8686ff, #8686ff) 0/var(--sx) 100% no-repeat, #f5f5f5;
}

/*ms*/
input[type=range].styled-slider::-ms-fill-upper {
  background: transparent;
  border-color: transparent;
}

input[type=range].styled-slider::-ms-fill-lower {
  background: transparent;
  border-color: transparent;
}

input[type=range].styled-slider::-ms-thumb {
  width: 20px;
  height: 20px;
  border-radius: 1em;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border: none;
  box-shadow: 0 0 2px black;
  margin-top: 0;
  box-sizing: border-box;
}

input[type=range].styled-slider::-ms-track {
  height: 1em;
  border-radius: 0.5em;
  background: #efefef;
  border: 1px solid #8686ff;
  box-shadow: none;
  box-sizing: border-box;
}

input[type=range].styled-slider::-ms-thumb:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

input[type=range].styled-slider:hover::-ms-track {
  background: #e5e5e5;
  border-color: #8686ff;
}

input[type=range].styled-slider::-ms-thumb:active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

input[type=range].styled-slider:active::-ms-track {
  background: #f5f5f5;
  border-color: #8686ff;
}

input[type=range].styled-slider.slider-progress::-ms-fill-lower {
  height: max(1em - 1px - 1px, 0px);
  border-radius: 0.5em 0 0 0.5em;
  margin: -1px 0 -1px -1px;
  background: #8686ff;
  border: 1px solid #8686ff;
  border-right-width: 0;
}

input[type=range].styled-slider.slider-progress:hover::-ms-fill-lower {
  background: #8686ff;
  border-color: #8686ff;
}

input[type=range].styled-slider.slider-progress:active::-ms-fill-lower {
  background: #8686ff;
  border-color: #8686ff;
}`, "",{"version":3,"sources":["webpack://./src/components/common/RangeInput/RangeInput.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,wBAAA;AAKF;;AAFA,mBAAA;AACA;EACE,sCAAA;EACA,yDAAA;EACA,mDAAA;AAKF;;AAFA;EACE,aAAA;AAKF;;AAFA,SAAA;AACA;EACE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,YAAA;EAEA,gBAAA;AAIF;;AADA;EACE,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBC/BS;EDgCT,gBAAA;AAIF;;AADA;EACE,mDAAA;AAIF;;AADA;EACE,mBCxCS;EDyCT,qBC1CS;AD8CX;;AADA;EACE,mDAAA;AAIF;;AADA;EACE,mBCjDS;EDkDT,qBCnDS;ADuDX;;AADA;EACE,iFAAA;AAIF;;AADA;EACE,iFAAA;AAIF;;AADA;EACE,iFAAA;AAIF;;AADA,UAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,YAAA;EACA,yBAAA;AAIF;;AADA;EACE,iCAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAIF;;AAGA;EACE,mBAAA;EACA,qBC1FS;AD0FX;;AAGA;EACE,mDAAA;AAAF;;AAGA;EACE,mBAAA;EACA,qBCnGS;ADmGX;;AAGA;EACE,iFAAA;AAAF;;AAGA;EACE,iFAAA;AAAF;;AAGA;EACE,iFAAA;AAAF;;AAGA,KAAA;AACA;EACE,uBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;AAAF;;AAGA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,mDAAA;AAAF;;AAGA;EACE,mBAAA;EACA,qBCvJS;ADuJX;;AAGA;EACE,mDAAA;AAAF;;AAGA;EACE,mBAAA;EACA,qBChKS;ADgKX;;AAGA;EACE,iCAAA;EACA,8BAAA;EACA,wBAAA;EACA,mBCvKS;EDwKT,yBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,mBC7KS;ED8KT,qBC9KS;AD8KX;;AAGA;EACE,mBClLS;EDmLT,qBCnLS;ADmLX","sourcesContent":["@use 'styles/colors';\n\ninput[type='range'].styled-slider {\n  height: 20px;\n  -webkit-appearance: none;\n}\n\n/*progress support*/\ninput[type='range'].styled-slider.slider-progress {\n  --range: calc(var(--max) - var(--min));\n  --ratio: calc((var(--value) - var(--min)) / var(--range));\n  --sx: calc(0.5 * 2em + var(--ratio) * (100% - 2em));\n}\n\ninput[type='range'].styled-slider:focus {\n  outline: none;\n}\n\n/*webkit*/\ninput[type='range'].styled-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 1em;\n  background: url(../../../assets/RangePoint.svg);\n  border: none;\n  // box-shadow: 0 0 2px black;\n  margin-top: calc(max((10px - 1px - 1px) * 0.5, 0px) - 16px * 0.5);\n}\n\ninput[type='range'].styled-slider::-webkit-slider-runnable-track {\n  height: 1em;\n  border: 1px solid colors.$primary3;\n  border-radius: 0.5em;\n  background: colors.$primary4;\n  box-shadow: none;\n}\n\ninput[type='range'].styled-slider::-webkit-slider-thumb:hover {\n  background: url(../../../assets/RangePoint.svg);\n}\n\ninput[type='range'].styled-slider:hover::-webkit-slider-runnable-track {\n  background: colors.$primary4;\n  border-color: colors.$primary3;\n}\n\ninput[type='range'].styled-slider::-webkit-slider-thumb:active {\n  background: url(../../../assets/RangePoint.svg);\n}\n\ninput[type='range'].styled-slider:active::-webkit-slider-runnable-track {\n  background: colors.$primary4;\n  border-color: colors.$primary3;\n}\n\ninput[type='range'].styled-slider.slider-progress::-webkit-slider-runnable-track {\n  background: linear-gradient(colors.$primary4, colors.$primary4) 0 / var(--sx) 100% no-repeat, #ffffff;\n}\n\ninput[type='range'].styled-slider.slider-progress:hover::-webkit-slider-runnable-track {\n  background: linear-gradient(colors.$primary4, colors.$primary4) 0 / var(--sx) 100% no-repeat, #ffffff;\n}\n\ninput[type='range'].styled-slider.slider-progress:active::-webkit-slider-runnable-track {\n  background: linear-gradient(colors.$primary4, colors.$primary4) 0 / var(--sx) 100% no-repeat, #ffffff;\n}\n\n/*mozilla*/\ninput[type='range'].styled-slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 1em;\n  background: url(../../../assets/RangePoint.svg);\n  border: none;\n  box-shadow: 0 0 2px black;\n}\n\ninput[type='range'].styled-slider::-moz-range-track {\n  height: max(calc(1em - 1px - 1px), 0px);\n  border: 1px solid colors.$primary3;\n  border-radius: 0.5em;\n  background: #efefef;\n  box-shadow: none;\n}\n\n// input[type='range'].styled-slider::-moz-range-thumb:hover {\n//   background: #0061c3;\n// }\n\ninput[type='range'].styled-slider:hover::-moz-range-track {\n  background: #e5e5e5;\n  border-color: colors.$primary3;\n}\n\ninput[type='range'].styled-slider::-moz-range-thumb:active {\n  background: url(../../../assets/RangePoint.svg);\n}\n\ninput[type='range'].styled-slider:active::-moz-range-track {\n  background: #f5f5f5;\n  border-color: colors.$primary3;\n}\n\ninput[type='range'].styled-slider.slider-progress::-moz-range-track {\n  background: linear-gradient(colors.$primary3, colors.$primary3) 0 / var(--sx) 100% no-repeat, #efefef;\n}\n\ninput[type='range'].styled-slider.slider-progress:hover::-moz-range-track {\n  background: linear-gradient(colors.$primary3, colors.$primary3) 0 / var(--sx) 100% no-repeat, #e5e5e5;\n}\n\ninput[type='range'].styled-slider.slider-progress:active::-moz-range-track {\n  background: linear-gradient(colors.$primary3, colors.$primary3) 0 / var(--sx) 100% no-repeat, #f5f5f5;\n}\n\n/*ms*/\ninput[type='range'].styled-slider::-ms-fill-upper {\n  background: transparent;\n  border-color: transparent;\n}\n\ninput[type='range'].styled-slider::-ms-fill-lower {\n  background: transparent;\n  border-color: transparent;\n}\n\ninput[type='range'].styled-slider::-ms-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 1em;\n  background: url(../../../assets/RangePoint.svg);\n  border: none;\n  box-shadow: 0 0 2px black;\n  margin-top: 0;\n  box-sizing: border-box;\n}\n\ninput[type='range'].styled-slider::-ms-track {\n  height: 1em;\n  border-radius: 0.5em;\n  background: #efefef;\n  border: 1px solid colors.$primary3;\n  box-shadow: none;\n  box-sizing: border-box;\n}\n\ninput[type='range'].styled-slider::-ms-thumb:hover {\n  background: url(../../../assets/RangePoint.svg);\n}\n\ninput[type='range'].styled-slider:hover::-ms-track {\n  background: #e5e5e5;\n  border-color: colors.$primary3;\n}\n\ninput[type='range'].styled-slider::-ms-thumb:active {\n  background: url(../../../assets/RangePoint.svg);\n}\n\ninput[type='range'].styled-slider:active::-ms-track {\n  background: #f5f5f5;\n  border-color: colors.$primary3;\n}\n\ninput[type='range'].styled-slider.slider-progress::-ms-fill-lower {\n  height: max(calc(1em - 1px - 1px), 0px);\n  border-radius: 0.5em 0 0 0.5em;\n  margin: -1px 0 -1px -1px;\n  background: colors.$primary3;\n  border: 1px solid colors.$primary3;\n  border-right-width: 0;\n}\n\ninput[type='range'].styled-slider.slider-progress:hover::-ms-fill-lower {\n  background: colors.$primary3;\n  border-color: colors.$primary3;\n}\n\ninput[type='range'].styled-slider.slider-progress:active::-ms-fill-lower {\n  background: colors.$primary3;\n  border-color: colors.$primary3;\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`
};
export default ___CSS_LOADER_EXPORT___;
